import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MenuComponent } from '../components/menu/menu.component';

import { IonicModule } from '@ionic/angular';
import { HeaderComponent } from '../components/header/header.component';
import { AuthService } from '../services/auth.service';
import { AuthenticationService } from '../services/authentication.service';
import { FilterPipe } from '../services/filter';
import { TruncatePipe } from '../services/truncate.pipe';



@NgModule({
  declarations: [MenuComponent,HeaderComponent,FilterPipe,TruncatePipe],
  providers: [AuthService,AuthenticationService],
  imports: [
    CommonModule,
    IonicModule
  ],
  exports: [MenuComponent,HeaderComponent, IonicModule,FilterPipe,TruncatePipe],

})
export class SharedModule { }
